import { isVideoHistoryStatus } from '@shared/index'
import { createFileRoute } from '@tanstack/react-router'

import { parseHistoryPage } from '@/lib/utils/history-search'

import PageVideoGenerationHistory from '../pages/PageVideoGenerationHistory'

type VideoGenerationHistorySearch = { status: string; creator?: string; page: number }

export const Route = createFileRoute('/video-generation-history')({
  component: PageVideoGenerationHistory,
  validateSearch: (search: Record<string, unknown>): VideoGenerationHistorySearch => ({
    page: parseHistoryPage(search.page),
    creator: typeof search.creator === 'string' ? search.creator : '',
    status: isVideoHistoryStatus(search.status) ? search.status : ''
  })
})
